import svgUrl from "ni:svgr;gvseaOlfaZAI5ZSRldrBl5jD0bPkQoWPLBz3Xi589e4";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiOutputSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9 2H3v12h9V5h-2a1 1 0 0 1-1-1V2Zm4 3L9 1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V5Zm-7.854 5.354a.5.5 0 0 1 .708-.708L7 10.793V6a.5.5 0 0 1 1 0v4.793l1.146-1.147a.5.5 0 1 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiOutputSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiOutputSIcon)";
}